import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import HotelPartnersPage from "@/pages/HotelPartnersPage";
import HospitalPartnersPage from "@/pages/HospitalPartnersPage";
import DonatePage from "@/pages/DonatePage";
import DonateSuccessPage from "@/pages/DonateSuccessPage";
import AdminPage from "@/pages/AdminPage";
import StoriesPage from "@/pages/StoriesPage";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <BrowserRouter>
        <Navbar />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/stories" element={<StoriesPage />} />
            <Route path="/hotel-partners" element={<HotelPartnersPage />} />
            <Route path="/hospital-partners" element={<HospitalPartnersPage />} />
            <Route path="/donate" element={<DonatePage />} />
            <Route path="/donate/success" element={<DonateSuccessPage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
